import { ErrorNotification, P, Stack } from '@ovotech/element-v5';
import { Card } from '@ovotech/nebula';
import React from 'react';
import { PAGE_TITLE } from '../PAYGTopupHistoryPage';
import { Heading } from './TopupHistoryList.styled';

export const ErrorView = () => (
  <Stack spaceBetween={8}>
    <Card>
      <Heading>{PAGE_TITLE}</Heading>
    </Card>
    <ErrorNotification
      id="topup-history-empty"
      title="We can’t load your top-up history right now"
    >
      <P size="sm">
        We're having trouble connecting to our servers. Your data is safe, but
        we can't display it at the moment. Please try again in a few minutes.
      </P>
    </ErrorNotification>
  </Stack>
);
